import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { getGridItemWidth } from '@/utils/gridItemWidth';

const GRID_GAP = theme.spacing[3];

export const styles = StyleSheet.create((colors, rt) => ({
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: theme.spacing[3],
    gap: GRID_GAP,
  },
  gridItem: (numColumns: number) => ({
    height: 'auto' as const,
    width: getGridItemWidth({
      screenWidth: Math.min(theme.breakpoints.tablet, rt.screen.width),
      horizontalPadding: theme.spacing[5] * 2,
      gap: GRID_GAP,
      numColumns,
    }),
  }),
  showAllButton: {
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.m,
  },
}));
